export default __webpack_public_path__ + "static/brand_guide@2x-7ddf4a1a11a08aff91a1d23268fb5575.png";